import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
	selector: '[appPositiveIntegerOnly]',
})
export class PositiveIntegerOnly {
	constructor(private el: ElementRef) {}

	@HostListener('keydown', ['$event'])
	onKeyDown(event: KeyboardEvent) {
		const key = event.key;

		// Allow: digits 0-9, Backspace, Delete, Tab, Arrows, Home/End
		if (
			/[0-9]/.test(key) ||
			['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(
				key
			)
		) {
			return; // allow
		}

		// Block everything else: -, +, ., e, letters, etc.
		event.preventDefault();
	}

	@HostListener('paste', ['$event'])
	onPaste(event: ClipboardEvent) {
		const pasted = (event.clipboardData || (window as any).clipboardData).getData('text');
		if (!/^\d*$/.test(pasted)) {
			// only digits
			event.preventDefault();
		}
	}

	@HostListener('input', ['$event'])
	onInput(event: Event) {
		const input = event.target as HTMLInputElement;
		const cleaned = input.value.replace(/[^0-9]/g, '');
		if (input.value !== cleaned) {
			input.value = cleaned;
			// Trigger Angular change detection / form update
			input.dispatchEvent(new Event('input'));
		}
	}
}
